import React,{Component,PropTypes} from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import {FormattedMessage} from "react-intl";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from 'prop-types';
import * as sActs from '../actions/server-actions';



class AgeVerify extends Component {


  constructor(props) {
    super(props);
    let show = true;
    let showC = sActs.getServerCookie(props.WebPage.ServerParams.Cookies,"siteways-verify") || "true";
    if (showC === "true") { show = true; } else { show = false; }
    let isBot = sActs.isBot(this.props.WebPage.ServerParams.UserAgent)
    if (isBot) show = false;
    this.state = {
      showingVerify: show
    };
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }



  handleAgree(e) {
    e.preventDefault();
    let domain = "." + wActs.getSubdomain(window.location.hostname);
    wActs.setCookie("siteways-verify", false, { path: "/", maxAge: 31557600, domain: domain});
    this.setState({ showingVerify: false });
  }

  render() {
    if (!this.state.showingVerify) {
      return null;
    }
    return (
      <div>
      <div className={"warning-popup-bg" + (this.state.showingVerify ? " active" : "")}></div>
      <div className={"warning-popup" + (this.state.showingVerify ? " active" : "")}>
        <div className="warning-popup-content">
          <div className="left-model" > <img src="/imgs/warning-popup-model-left.png" alt="Warning1"/></div>
          <div className="right-model"><img src="/imgs/warning-popup-model-right.png" alt="Warning2" /></div>
          <div className="popup-header">18+ Warning</div>
          <div className="inner-content">
            <div className="warning-text" dangerouslySetInnerHTML={{__html: this.getTranslation("page.warning")}}></div>
            <div className="centered-content small-mb"><a style={{cursor: "pointer", width: "100%"}} onClick={(e) => {this.handleAgree(e)}} title="" className="button grey close-adult-warning"><FormattedMessage id={"menu.enterwebsite"}>{(...content) => content}</FormattedMessage></a></div>
          </div>
      </div>
      </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
};

export default connect(mapStateToProps)(AgeVerify);
